module.exports = __webpack_public_path__ + "media/markers/marker-light-blue-2251520a.svg";